module.exports = __webpack_public_path__ + "static/media/splash-photo-center.96aaea08.jpg";